import { gql } from '@apollo/client/core';

import {
  CoreTicketFieldsFragmentDoc,
  TicketAttachmentsFragmentDoc,
} from '@generatedTypes';

export const TICKET_BY_CODE = gql`
  ${CoreTicketFieldsFragmentDoc}
  ${TicketAttachmentsFragmentDoc}
  query TicketByCode($code: String!) {
    ticketByCode(code: $code) {
      ...CoreTicketFields
      ...TicketAttachments
    }
  }
`;

export const GET_ALL_NON_COMPLIANCES_BY_TICKET = gql`
  query nonCompliancesByTicket($ticket_id: ID!) {
    nonCompliancesByTicket(ticket_id: $ticket_id) {
      id
      ticket_id
      type
      internal_code
    }
  }
`;
